import { ObjectTools } from '../tools/object-tools';
import { StorageService } from './storage.service';

export class LocalStorageService implements StorageService {
  constructor(private prefix: string) {}

  public set<A>(key: string, value: A | undefined): void {
    const fullKey = this.prefix + '.' + key;
    if (ObjectTools.isNull(value)) {
      console.debug('Removing key from localStorage (null): ' + fullKey);
      localStorage.removeItem(fullKey);
      return;
    }
    console.debug('Setting key in localStorage: ' + fullKey);
    localStorage.setItem(fullKey, JSON.stringify(value));
  }

  public get<A>(key: string): A | undefined {
    const item = localStorage.getItem(this.prefix + '.' + key);
    console.debug('Retrieved item from localStorage: ' + this.prefix + '.' + key);
    if (!item) return undefined;
    try {
      return JSON.parse(item);
    } catch {
      return undefined;
    }
  }

  public remove(key: string): void {
    const fullKey = this.prefix + '.' + key;
    console.debug('Removing key from localStorage: ' + fullKey);
    localStorage.removeItem(fullKey);
  }

  clear(): void {
    localStorage.clear();
  }
}
